// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1Tttk","label":"Labeled_label__1nTNk","divider":"Labeled_divider__1y-zQ"};